export default __webpack_public_path__ + "static/media/moonpay.dcb5ed11.svg";